import { action } from 'satcheljs';
import { DateRange } from 'owa-datetime-utils';

export const loadCalendarCache = action('loadCalendarCache');

export const cancelRefreshUpNextPoll = action('cancelRefreshUpNextPoll', (scenarioId: string) => ({
    scenarioId,
}));

export const loadEventsForDateRange = action(
    'loadEventsForDateRange',
    (folderIds: string[], dateRange: DateRange, scenarioId: string) => ({
        folderIds,
        dateRange,
        scenarioId,
    })
);

export const initializeRefreshUpNextPoll = action(
    'initializeRefreshUpNextPoll',
    (folderIds: string[], dateRange: DateRange, scenarioId: string) => ({
        folderIds,
        dateRange,
        scenarioId,
    })
);

export const refreshUpNextCalendarEventAction = action(
    'refreshUpNextCalendarEventAction',
    (folderIds: string[], scenarioId: string) => ({ folderIds, scenarioId })
);

export const setUpNextCalendarEventInStore = action(
    'setUpNextCalendarEventInStore',
    (upNext: { id: string | null; index: number | null }, scenarioId: string) => ({
        upNext,
        scenarioId,
    })
);

export const updateSelectedCalendarEvent = action(
    'updateSelectedCalendarEvent',
    (selectedCalendarEventId: string, scenarioId: string) => ({
        selectedCalendarEventId,
        scenarioId,
    })
);

export const updateLoadingInitialData = action(
    'updateLoadingInitialData',
    (isLoading: boolean, scenarioId: string) => ({ isLoading, scenarioId })
);

export const initializePane = action('initializePane', (scenarioId: string) => ({ scenarioId }));
